import { LuxInputSwitch } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import Scheduling from '../../Scheduling/Scheduling'
import { FormBase, SchedulingForm } from '@/app/models/new-activity-form'
import { NewActivitySectionType } from '@/app/models/new-activity-section-type'
import { surveyTaskForm } from '@/app/models/new-activity-survey-task-form'
import './SurveyTaskScheduling.scss'

const SurveyTaskScheduling = (props: FormBase<SchedulingForm>) => {
    const componentClass = 'smart-new-activity-survey-task-scheduling'
    const intl = useIntl()
    const { form, onSetForm, onSave, isDone } = props

    const afterAutoClose = (
        <div  className={`${componentClass}__field-container`}>
            <LuxInputSwitch
                onChangeCallback={() =>
                    onSetForm({
                        ...form,
                        calendarVisibility: { value: !form.calendarVisibility.value },
                    })
                }
                value={form.calendarVisibility.value}
                title={intl.formatMessage({
                    id: `modals.new.activity.section.scheduling.calendar.visibility`,
                    defaultMessage: 'Set calendar visibility',
                })}
                label={intl.formatMessage({
                    id: `modals.new.activity.section.scheduling.calendar.visibility.label`,
                    defaultMessage: 'Task Visible in Calendar',
                })}
                additionalProps={{ disabled: form.calendarVisibility.disabled }}
            />
        </div>
    )
    return (
        <div className={componentClass}>
            <Scheduling
                afterAutoClose={afterAutoClose}
                form={form}
                onSetForm={(form) => onSetForm(form)}
                onSave={() => onSave()}
                onClear={() =>
                    onSetForm({ ...surveyTaskForm[NewActivitySectionType.SCHEDULING] })
                }
                isDone={isDone}
            />
        </div>
    )
}

export default SurveyTaskScheduling
